'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryGet = countryGet;
function countryGet() {
  return {
    type: 'COUNTRY',
    promise: function promise(_ref) {
      var api = _ref.api;
      return api('/country').get();
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/country.js
// module id = 2428
// module chunks = 0